import { render, staticRenderFns } from "./DiscoveryCreate.vue?vue&type=template&id=009653db&"
import script from "./DiscoveryCreate.vue?vue&type=script&lang=js&"
export * from "./DiscoveryCreate.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports